import { MessageDescriptor } from "react-intl";
import {Customer} from "./Models/Customer";
import {Role} from "./Models/Role";
import {Option} from "../DefaultSettings/Settings/FieldWrapper";
import {User} from "./Models/User";
import { TreeDropdownOption } from "@Elements/Dropdown/types";
import { CustomerPermission } from "@Safemate/Policy/Provider";
import { CustomerWithChildren } from "@Safemate/Model/Customer";

export type TranslateOptions = (items: Array<any>, formatMesssage: (message: MessageDescriptor) => string) => Array<any>;
export type MapRoles = (roles: Array<Role>) => Array<Option>;
export type RecursiveCustomer = (children: Array<CustomerWithChildren>, check:boolean) => Array<TreeDropdownOption>;

export const translateOptions: TranslateOptions = (items, formatMessage) => {
  const translatedItems: Array<any> = [];
  items.forEach(item => {
    translatedItems.push({...item, text: formatMessage({id: item.text, defaultMessage: item.text})});
  })
  return translatedItems;
}

export const translateOptionsExport: TranslateOptions = (items, formatMessage) => {
  const translatedItems: Array<String> = [];
  items.forEach(item => {
    if( item.export === undefined || item.export ){
      translatedItems.push(formatMessage({id: item.text, defaultMessage: item.text}).toUpperCase());
    }    
  })
  return translatedItems;``
}

export interface HierarchyMapOptions{
  singleSelect?: boolean;
  includeTop?: boolean;
}

const getChildPermission = (children: CustomerWithChildren[], permissions: CustomerPermission, permissionTypes: string[], hasPermissions: boolean) => {
  for(const child of children){
    permissionTypes.forEach(perm => {
      if(permissions[child.customer.custId] && permissions[child.customer.custId][perm]){
        hasPermissions = true;
      }
    })
    hasPermissions = hasPermissions || getChildPermission(child.children, permissions, permissionTypes, hasPermissions);
  }
  return hasPermissions;
}
``
export const mapCustomersForUser = (selectedCustIds: number[], customers: CustomerWithChildren, permissions: CustomerPermission, permissionTypes: string[], options: HierarchyMapOptions = {}) => {

  const recursive: RecursiveCustomer = (children, check) => {
    

    return children.map((child: CustomerWithChildren) => {

      const childHasPermssions = getChildPermission(child.children, permissions, permissionTypes, false)

      let mappedChildren: TreeDropdownOption[] | null = null;

      let disabled = true;
      let showChildren = false;

      permissionTypes.forEach(perm => {
        if(permissions[child.customer.custId] && permissions[child.customer.custId][perm]){
          disabled = false;
        }
      })

      
      const checked: boolean = selectedCustIds.includes(child.customer.custId) || (check && !options.singleSelect);
      let locked: boolean = check;
      
      if(disabled){
        showChildren = childHasPermssions;
        locked = childHasPermssions;
      }
      if(child.children){
        mappedChildren = recursive(child.children, checked);
      }

      showChildren = showChildren ||
        options.singleSelect ||
        (!!mappedChildren &&
        !!mappedChildren
          .find((mappedChild: TreeDropdownOption) =>
            mappedChild.checked || (mappedChild.disabled && mappedChild.showChildren) || (!mappedChild.disabled && disabled)
          ))

      const option: TreeDropdownOption = {
        disabled,
        checked,
        locked,
        showChildren,
        key: child.customer.custId.toString(),
        name: child.customer.firmName,
        children: mappedChildren
      }

      return option;

    }) as TreeDropdownOption[];
  }

  if(customers.children)
    if(options.includeTop){
      let topChecked = selectedCustIds.includes(customers.customer.custId);
      return [{
        disabled: false,
        checked: topChecked,
        locked: false,
        showChildren: (topChecked || options.singleSelect),
        key: customers.customer.custId.toString(),
        name: customers.customer.firmName,
        children: recursive(customers.children, topChecked)
      }]
    }
    else{
      return recursive(customers.children, false);
    }
  return [];
}

export const user = (): User =>{
  return {
    userId: 0,
    active: false,
    deactivated: false,
    tempDeactivated: false,
    trained: false,
    name: "",
    firstName: "",
    lastName: "",
    username: "",
    mobile: "",
    email: "",
    mailTo: "",
    coveredByTwoFactorAuthentication: false,
    trainingApprovedByName: "",
    trainingApprovedBy: 0,
    userType: 0,
    deactivatedFrom: "",
    deactivatedTo: "",
    lastActivity: 0,
    emailAsUsername: false,
    newUserFlag: false,
    mapConsent: false,
    lastSso: "",
    languageCode: "en",
    beta: false
  }
}
